import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import axios from "axios";
import { motion } from "framer-motion";
import { Footer } from "./Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const LegalLayout = ({ title, subtitle, eyebrow = "Rechtliches", hero, children }) => {
  const [businessInfo, setBusinessInfo] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${API}/business-info`)
      .then((res) => setBusinessInfo(res.data))
      .catch(() => {});
  }, []);

  return (
    <div className="bg-[#F9F8F6] min-h-screen flex flex-col">
      {/* Top bar */}
      <header
        className={hero ? "absolute top-0 left-0 right-0 z-50 py-5" : "glass-nav py-4"}
        data-testid="legal-header"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-logo-home"
            className={`font-logo text-3xl md:text-4xl leading-none ${hero ? "text-white" : "text-[#1A1A1A]"}`}
          >
            Urban Beauty
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className={`flex items-center gap-2 text-sm tracking-wider uppercase font-medium transition-colors duration-300 hover:text-[#C5A059] ${hero ? "text-white" : "text-[#1A1A1A]"}`}
          >
            <ArrowLeft size={16} />
            Zur Startseite
          </Link>
        </div>
      </header>

      {/* Full-bleed hero (optional) */}
      {hero && <div data-testid="legal-hero">{hero}</div>}

      {/* Content */}
      <main className={`flex-1 pb-24 px-6 md:px-12 lg:px-24 ${hero ? "pt-16" : "pt-32"}`}>
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {!hero && (
              <>
                <p className="text-sm tracking-[0.3em] uppercase text-[#C5A059] mb-4">
                  {eyebrow}
                </p>
                <h1
                  className="font-playfair text-4xl sm:text-5xl lg:text-6xl text-[#1A1A1A] mb-4"
                  data-testid="legal-title"
                >
                  {title}
                </h1>
                {subtitle && (
                  <p className="text-[#666666] text-base mb-12 max-w-xl">{subtitle}</p>
                )}
              </>
            )}
            <div className="legal-content text-[#1A1A1A]">
              {children}
            </div>
          </motion.div>
        </div>
      </main>

      <Footer businessInfo={businessInfo} />
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section className="mt-16 md:mt-28 first:mt-0 space-y-5">
    {heading && (
      <h2 className="font-playfair text-2xl md:text-3xl text-[#1A1A1A]">{heading}</h2>
    )}
    <div className="text-[#666666] leading-relaxed space-y-4 text-base">
      {children}
    </div>
  </section>
);
